module.exports = __webpack_public_path__ + "static/media/tape.9f25cf3a.svg";